export enum Constants {
  SET_ORGANIZATION_EDIT = 'SET_ORGANIZATION_EDIT',
  SET_ORGANIZATION_DELETE = 'SET_ORGANIZATION_DELETE',
}

export interface Role {
  id: number
  title: string
  value: number
}

export enum Roles {
  USER = 1,
  NETWORK_ADMIN = 25,
  ORGANIZATION_ADMIN = 50,
  SUPER_ADMIN = 100,
}
